import PropTypes from 'prop-types';

export const IdentificationTypePropType = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  identificationInCountry: PropTypes.string,
});

export const CustomerPropType = PropTypes.shape({
  id: PropTypes.number,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  addressId: PropTypes.number,
  idDocumentNumber: PropTypes.string,
  idCountryOfOrigin: PropTypes.string,
  gender: PropTypes.string,
  dob: PropTypes.string,
  identificationTypeId: PropTypes.number,
  identificationType: IdentificationTypePropType,
  mobilePhone: PropTypes.string,
  homePhone: PropTypes.string,
  workPhone: PropTypes.string,
  fax: PropTypes.string,
  email: PropTypes.string,
  fullName: PropTypes.string,
  isBusAssignmentChanger: PropTypes.bool,
});

export const FreeOfChargeSubCategoryUserPropType = PropTypes.shape({
  id: PropTypes.number,
  freeOfChargeSubCategoryId: PropTypes.number,
  customerId: PropTypes.number,
  customer: CustomerPropType,
  active: PropTypes.bool,
});

export const FreeOfChargeSubCategoryPropType = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  freeOfChargeCategoryId: PropTypes.number,
  freeOfChargeSubCategoryUserList: PropTypes.arrayOf(
    FreeOfChargeSubCategoryUserPropType,
  ),
  active: PropTypes.bool,
  createDate: PropTypes.number,
});

export const FreeOfChargeCategoryPropType = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  description: PropTypes.string,
  active: PropTypes.bool,
  createDate: PropTypes.number,
  freeOfChargeSubCategoryList: PropTypes.arrayOf(
    FreeOfChargeSubCategoryPropType,
  ),
});
